package org.example.project.service

import org.example.project.utils.All

object HofService {

    private var layout: All? = null
    private var records: List<All> = emptyList()

    /* ================= BIND ================= */

    fun bind(
        layoutAll: All?,
        allRecords: List<All>
    ) {
        layout = layoutAll
        records = allRecords
    }
    /* ================= TORE ================= */

    fun getTorIds(): List<Int> =
        layout?.standortTore
            ?.mapNotNull { it["id"] }
            ?: emptyList()

    fun getBelegung(torId: Int): All? =
        records.firstOrNull {
            it.tor == torId && isTorAktiv(it.zustand)
        }

    fun isTorFrei(torId: Int): Boolean =
        getBelegung(torId) == null

    fun getTorZustand(torId: Int): Int =
        getBelegung(torId)?.zustand ?: ZustandManager.ANGELEGT

    /* ================= HELPER ================= */

    private fun isTorAktiv(z: Int): Boolean =
        z > ZustandManager.RESERVIERT && z < ZustandManager.ABGESCHLOSSEN
}
